import { Box } from "@mui/material";
import CircularProgress, {
  CircularProgressProps,
  circularProgressClasses,
} from "@mui/material/CircularProgress";

interface LoaderProps extends CircularProgressProps {
  /** Color of the spinning indicator. Defaults to primary.main (purple). */
  indicatorColor?: string;
}

const Loader = ({ indicatorColor = "primary.main", ...props }: LoaderProps) => {
  return (
    <Box sx={{ position: "relative", height: props.size ?? 40 }}>
      <CircularProgress
        variant="determinate"
        sx={{
          color: (theme) => theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
        }}
        size={40}
        thickness={4}
        {...props}
        value={100}
      />
      <CircularProgress
        variant="indeterminate"
        disableShrink
        sx={{
          color: indicatorColor,
          animationDuration: "550ms",
          position: "absolute",
          left: 0,
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: "round",
          },
        }}
        size={40}
        thickness={4}
        {...props}
      />
    </Box>
  );
};

export default Loader;
